const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded', function() {
    
    const el = document.getElementById('offersChoice');
    
    const init = function() {

        let appla = document.getElementsByClassName('js-appla')[0],
            trigger = document.getElementsByClassName('js-openOffersChoice'),
            offerTrigger = document.getElementsByClassName('js-showOffers'),
            popWindow = document.getElementsByClassName('js-popupWindow')[0],
            closePopup = document.getElementsByClassName('js-closePopup')[0];

        const checkPopHeight = function() {
           
            if (popWindow.clientHeight >= window.innerHeight) {
                popWindow.classList.add('is-relative');
            } else {
                popWindow.classList.remove('is-relative');
            }
        }

        const open = function(e) {            
            
            disableBodyScroll(el);

            document.getElementsByClassName('site_inner')[0].classList.add('hide');
            document.getElementsByClassName('c-offerschoice')[0].classList.remove('hide');
            
            appla.classList.add('is-visible');
            
            el.classList.add('is-visible');
            
            setTimeout(function() {
                
                el.classList.add('fade-in');
                
            }, 100);
            
            checkPopHeight();
            window.addEventListener('resize', checkPopHeight);

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        };

        const showOffers = function(e) {
            document.getElementsByClassName('site_inner')[0].classList.remove('hide');
            document.getElementsByClassName('c-offerschoice')[0].classList.add('hide');
            checkPopHeight();
        };
        
        const close = function() {            
            
            enableBodyScroll(el);
            
            el.classList.remove('fade-in');
            
            setTimeout(function() {
                
                appla.classList.remove('is-visible');
                el.classList.remove('is-visible');
                window.removeEventListener('resize', checkPopHeight);
                
            }, 100);
        };

        for (let i = 0; i < offerTrigger.length; i++) {
            offerTrigger[i].addEventListener('click', showOffers);
        }

        for (let i = 0; i < trigger.length; i++) {
            trigger[i].addEventListener('click', open);
        }
        
        closePopup.addEventListener('click', close);


        // Hide menu on ESC

        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                close();
            }
        });
    };



    el ? init() : false;
        
}, false);



